/**
 * <x-sky> — Declarative sky-configuration element. Zero or one per scene.
 *
 *   <x-scene>
 *     <x-sky comp="sky.sun=0.2,0.9,0.3; sky.sunIlluminance=25"></x-sky>
 *   </x-scene>
 *
 * The element is a marker — settings are applied via `sky.*` comp keys on
 * the shared SkyModule instance (there's exactly one SkyModule per app).
 */

import { defineXElement, XBaseElement } from '../../../html/elements/defineXElement.js';

class XSkyElement extends XBaseElement {}

export function defineXSky(): void {
  defineXElement('x-sky', XSkyElement);
}
